import useSWR from "swr";
import { KeyframeGeography } from "lib/types/KeyframeGeography";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { fetcher } from "lib/actions/fetcher";

export function useProjectGeography(projectId: number) {
  const { data: trustedGeography } = useSWR<KeyframeGeography>(
    projectId && endpointsAssets.projectTrustedGeometry(projectId),
    fetcher,
  );
  const { data: untrustedGeography } = useSWR<KeyframeGeography>(
    projectId && endpointsAssets.projectUntrustedGeometry(projectId),
    fetcher,
  );

  return {
    trustedGeography,
    untrustedGeography,
  };
}
